import {Field, Upload} from "@bolteu/clay-react";

import {useI18n} from "i18n/i18n";
import {useAppDispatch} from "webform/store/hooks";
import {addAttachment, registerAttachments} from "webform/slices/attachmentSlice";
import {AttachmentList, FieldLabel} from "webform/components";

// Dropzone uses Clay's Upload; the uploaded-file rows stay redux-driven (AttachmentList)
// because they show per-file backend state — upload spinner, error, backend delete —
// which Clay's client-side Upload.Attachment rows don't model. onFilesAttached only fires
// for newly added files, so each upload is dispatched once.
export const Attachments = () => {
    const dispatch = useAppDispatch();
    const i18n = useI18n();

    const handleFilesAttached = async (files: File[]) => {
        dispatch(registerAttachments(files));
        for (const file of files) {
            await dispatch(addAttachment({file}));
        }
    };

    return (
        <>
            <Field.Root className="mt-6">
                <FieldLabel label={i18n("webform.attachment.title")} />
                <Upload.Root multiple className="w-full" onFilesAttached={handleFilesAttached}>
                    <Upload.Dropzone>
                        <div>
                            <Upload.PrimaryText>{i18n("webform.desktop.title")}</Upload.PrimaryText>
                            <Upload.SecondaryText>{i18n("webform.desktop.subtitle")}</Upload.SecondaryText>
                        </div>
                        <Upload.Trigger>{i18n("webform.attachment.button")}</Upload.Trigger>
                    </Upload.Dropzone>
                </Upload.Root>
            </Field.Root>
            <AttachmentList />
        </>
    );
};
